import { render } from "./LoginIcon.vue?vue&type=template&id=d72905b4"
import script from "./LoginIcon.vue?vue&type=script&lang=js"
export * from "./LoginIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__